import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import Spa from "../../assets/img/Featured/pc-appointments.png";
import Book from "../../assets/img/Featured/app-massage-spa.png";
import Retail from "../../assets/img/Featured/pc-retail.png";
import Book4Time from "../../assets/img/Featured/app-book4time.png";
import Book4TimeLogo from "../../assets/img/SolutionsIcons/Book4Time.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import { Header } from "../../components/Header";

const SpaPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent, location])
    const navigate = useNavigate();
    return(
        <div className="page spaPage">
            <Header />
            <div className="page-header">Spa</div>
            <div className="text-blocks">
                <div className="std-text">
                    Manage all your spa operations — from scheduling
                    services to managing staff — with a single solution
                    that connects effortlessly to your PMS. Improve
                    the therapist experience, simplify client engagement, 
                    and our Spa booking wizard delivers
                    a frictionless appointment process providing
                    visibility to service price, duration, comments,
                    setup time, breakdown time, and priority status.{'\n\n'}
                </div>
                <div className="std-text">
                    Our guestsense.ai-enabled solution helps
                    optimize revenue and provides a conversational
                    AI Concierge to fully automate the entire
                    reservation flow in a natural conversation.
                </div>
            </div>
            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Spa", "Spa");
                    addFlow("Spa");
                    navigate("/solutions/spa")}}>
                    <img src={Spa} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Spa
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Spa", "Book");
                    addFlow("Book");
                    navigate("/solutions/book")}}>
                    <img src={Book} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Book
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Spa", "Book4Time");
                    addFlow("Book4Time");
                    navigate("/solutions/book4time")}}>
                    <img src={Book4Time} alt="" />
                    <div className="item-head">
                        {/*<LogoMini />*/}
                        <img className="featured-logo" src={Book4TimeLogo} alt="" />
                    </div>
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Spa", "Retail");
                    addFlow("Retail");
                    navigate("/solutions/retail")}}>
                    <img src={Retail} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Retail
                    </div>
                </div>
            </FeaturedSolutions>
            
        </div>
    )
}

export default SpaPage;